import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

import { API_BASE_URL } from "../config";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleForgot = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API_BASE_URL}/Home/CompanyForgotPassword`, {
        email: email,
      });

      setMessage(response.data.message || "Reset link sent to your email.");
    } catch (error) {
      setMessage(error.response?.data?.message || "Something went wrong.");
    }
  };

  return (
    <div className="home">
    <div id="page" className="hfeed page-wrapper">
     
     
                    
                    <br/><br/>

                    <div className="new-login-container">
                      <div className="new-login-box">
                      <h2 className="new-login-title"><Link to="/" style={{ color: "black" }} className="btn btn-view"> <i className="fa fa-arrow-left" aria-hidden="true"></i></Link>Forgot Password</h2>
                      <form onSubmit={handleForgot} className="new-login-form">
                          {/* Email Input */}
                          <div className="new-input-group">
                            <label htmlFor="username">Enter your email</label>
                            <div className="new-input-wrapper">
                              <i className="fas fa-user" />
                              <input
                                type="text"
                                id="username"
                                className="new-input"
                                placeholder="Enter your registered email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                              />
                            </div>
                          </div>

                        
                          <button type="submit" className="new-login-btn">
          Send Reset Link
        </button>

                         
                        </form>
                        {message && <p style={{color:"black"}} className="mt-4 text-center text-sm text-gray-700">{message}</p>}
                      </div>
                    </div>
                    <br/><br/>
  
    </div>
    </div>
  );
};

export default ForgotPassword;
